import { CockpitPeriodKey } from '../model/types'

const QUARTER_BY_PERIOD: Partial<Record<CockpitPeriodKey, number>> = {
  q1: 1,
  q2: 2,
  q3: 3,
  q4: 4,
}

/** Whether the selected period still includes a quarter that hasn't closed yet (i.e. it's at or
 *  ahead of the current fiscal quarter, or Full Year). Once every selected quarter has passed,
 *  this is `false` — e.g. Expected Exit gives way to Actuals, and the Revenue & SOB table's
 *  Achievement SCORE columns appear. */
export const isPeriodOpen = (periods: CockpitPeriodKey[], currentFQuarter: number): boolean => {
  if (periods.includes('fullYear')) {
    return true
  }

  return periods.some((period) => (QUARTER_BY_PERIOD[period] ?? -Infinity) >= currentFQuarter)
}
